import { getEmployeeData, getInitialShift } from 'profile/redux.actions';
import {
    getAcademicInformation,
    getContactInformation,
    getFamilyInformation,
    getGeneralInformation,
    getIdentificationInformation,
    getOtherInformation
} from 'profile/utils/getStructureData';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function useUserData() {
    const RXDispatch = useDispatch();
    const [data, setData] = useState({});
    const [shiftData, setShiftData] = useState({});
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const email = id;
    const isSelf = searchParams.get('isSelf') === 'true' ? true : false;

    useEffect(() => {
        RXDispatch(getEmployeeData({ handleSubmit, payload: { email, isSelf } }));
        RXDispatch(
            getInitialShift({
                handleSubmit: handleGetManageShifts,
                payload: { employeeEmail: email, isSelf }
            })
        );
    }, [email]);

    const handleSubmit = (resp) => {
        setData({ ...resp.data });
    };

    const handleGetManageShifts = (shifts) => {
        setShiftData({ ...shifts });
    };

    if (!data.id || !shiftData) return {};

    return {
        dataGeneralInfo: getGeneralInformation(data),
        dataContactInfo: getContactInformation(data),
        dataFamilyInfo: getFamilyInformation(data),
        dataIdentificationInfo: getIdentificationInformation(data),
        dataAcademicInfo: getAcademicInformation(data),
        dataOtherInfo: getOtherInformation(data),
        shiftData
    };
}
